var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F4DAA6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 45.1667C37.7048 45.1667 45.1667 37.7048 45.1667 28.5C45.1667 19.2953 37.7048 11.8334 28.5 11.8334C19.2953 11.8334 11.8334 19.2953 11.8334 28.5C11.8334 37.7048 19.2953 45.1667 28.5 45.1667Z",
    stroke: "#744D01",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 13.5H23.5C20.25 23.2333 20.25 33.7667 23.5 43.5H21.8333",
    stroke: "#744D01",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 13.5C36.75 23.2333 36.75 33.7667 33.5 43.5",
    stroke: "#744D01",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 35.1667V33.5C23.2333 36.75 33.7667 36.75 43.5 33.5V35.1667",
    stroke: "#744D01",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23.5C23.2333 20.25 33.7667 20.25 43.5 23.5",
    stroke: "#744D01",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.0d29c696dc4fc39d21b2c10c1c656e7c.svg";
export { ForwardRef as ReactComponent };